import { render, staticRenderFns } from "./compliance_info.vue?vue&type=template&id=15d108f3"
import script from "./compliance_info.vue?vue&type=script&lang=js"
export * from "./compliance_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports